import { Outlet } from 'react-router-dom';
import { LeadProvider } from 'modules/lead';

const LeadWrapper = () => {
  return (
    <LeadProvider> 
      <Outlet />
    </LeadProvider> 
  );
};

export default LeadWrapper;